import React, { useState } from 'react'
import { Renta } from 'src/gql/schema'
import isTimeout from 'src/pages/home/components/RoomCard/helpers/isTimeout'
import PersonasExtra from 'src/pages/home/room-detail/Modals/PersonasExtra/PersonasExtra'
import Detail from 'src/shared/components/data-display/Detail/Detail'
import DetailAction from 'src/shared/components/data-display/Detail/kit/DetailAction/DetailAction'
import DetailContent from 'src/shared/components/data-display/Detail/kit/DetailContent/DetailContent'
import DetailIcon from 'src/shared/components/data-display/Detail/kit/DetailIcon/DetailIcon'
import DetailRow from 'src/shared/components/data-display/Detail/kit/DetailRow/DetailRow'
import DetailText from 'src/shared/components/data-display/Detail/kit/DetailText/DetailText'
import { RoleNames } from 'src/shared/hooks/useAuth'
import useIsColaboradorActive from 'src/shared/hooks/useIsColaboradorActive'
import { useProfile } from 'src/shared/hooks/useProfile'
import { useTimePulse } from 'src/shared/hooks/useTimePulse'

const Ocupacion = ({ ultima_renta, personas_extra_enabled }: { ultima_renta: Renta, personas_extra_enabled: boolean }) => {

    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()
    const { rolName } = useProfile()
    const [showModalPersonasExtra, setShowModalPersonasExtra] = useState<boolean>(false)
    const [now] = useTimePulse()
    const isTiempoExcedido = !!(ultima_renta?.fecha_condensada && isTimeout({ date: ultima_renta.fecha_condensada, now }))

    // const tarifaBase = ultima_renta.tarifas?.find((t) => t.grupo_tarifa?.modalidad === ModalidadGrupoTarifa.Base)

    return (
        <Detail color="white">
            <DetailIcon name="UserParentFill" />
            <DetailContent>
                <DetailRow>
                    <DetailText type="normal">
                        Ocupación
                    </DetailText>
                    {
                        !isTiempoExcedido &&
                        ![RoleNames.mantenimiento, RoleNames.monitoreo].includes(rolName as unknown as RoleNames) &&
                        <DetailAction disabled={!personas_extra_enabled} onClick={validateIsColabActive(() => setShowModalPersonasExtra(true))}>
                            {/* {(tarifaBase?.personas_extra_max || 0) - ultima_renta?.personas_extra > 0
                          ? "Agregar"
                          : undefined} */}
                            Agregar
                        </DetailAction>
                    }
                </DetailRow>
                <DetailRow>
                    <DetailText type="bold">
                        {`${ultima_renta.numero_personas} persona${ultima_renta.numero_personas > 1 ? "s" : ""}`}
                    </DetailText>
                </DetailRow>
                {
                    ultima_renta.personas_extra > 0 &&
                    <DetailRow>
                        <DetailText type="normal">
                            {ultima_renta.personas_extra > 1 ? `+ ${ultima_renta.personas_extra} personas extra` : `+ ${ultima_renta.personas_extra} persona extra`}
                        </DetailText>
                    </DetailRow>
                }
            </DetailContent>
            {InactiveModal}
            {showModalPersonasExtra && <PersonasExtra onClose={() => setShowModalPersonasExtra(false)} />}
        </Detail>
    )
}

export default Ocupacion
